export enum Messages {
  TerminationFee = 'Bruddgebyret varierer ut ifra hvilken type avtale/binding. Gebyret reduseres med en tolvtedel per måned regnet fra når inngått avtale. I tillegg kommer eventuelt restbeløp for nedbetaling av mobiltelefon.',
  NoTerminationFee = 'Dette abonnementet har ingen avtaletid, og dermed ingen bruddgebyr.',
}
